<template>
  <div class="page-router page-router-user">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
  export default {
    name: "page-router",
  }
</script>
<style scoped lang="scss">
  .page-router {
    // height: 100%;
  }
</style>
<style lang="scss">
  .page-router{
  }
</style>


